"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M14 30V14H4a2 2 0 0 0-2 2v26a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2V32H16a2 2 0 0 1-2-2z" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "4", x: "18", y: "24" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "4", x: "26", y: "24" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "4", x: "34", y: "24" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "4", x: "42", y: "24" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "4", x: "42", y: "16" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "4", x: "42", y: "8" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "4", x: "42" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "4", x: "34" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "4", x: "26" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "4", x: "18" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "4", x: "18", y: "8" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "4", x: "18", y: "16" })
);

